import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path, Defs, Stop, LinearGradient } from 'react-native-svg';

const DivideIconShadow = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 65}
          height={props.height ?? 59}
          viewBox="0 0 65 59"
          fill="none"
          {...props}
        >
          <Path
            d="M48.0322 45.324C49.568 44.4499 50.8125 42.2781 50.8125 40.5035L50.8125 17.7782C50.8125 16.0036 49.568 13.8582 48.0322 12.9576L28.3584 1.59499C26.8226 0.72094 24.3336 0.720939 22.7979 1.59499L3.12403 12.9576C1.58826 13.8317 0.343749 16.0036 0.343749 17.7782L0.343748 40.5035C0.343748 42.2781 1.58825 44.4235 3.12403 45.324L22.7978 56.6866C24.3336 57.5607 26.8226 57.5607 28.3584 56.6866L48.0322 45.324Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Path
            d="M42.0859 58.3683C37.8143 58.3683 34.6354 55.4182 34.6354 51.288C34.6354 47.1578 37.8143 44.2077 42.0859 44.2077C46.4569 44.2077 49.5365 47.1578 49.5365 51.288C49.5365 55.4182 46.4569 58.3683 42.0859 58.3683ZM19.7344 25.1302H64.4375V36.439H19.7344V25.1302ZM42.0859 18.2466C37.8143 18.2466 34.6354 15.2964 34.6354 11.1662C34.6354 7.03606 37.8143 4.08594 42.0859 4.08594C46.4569 4.08594 49.5365 7.03606 49.5365 11.1662C49.5365 15.2964 46.4569 18.2466 42.0859 18.2466Z"
            fill="url(#paint0_linear_1_39126)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_1_39126"
              x1="42.0859"
              y1="4.08594"
              x2="42.0859"
              y2="58.3683"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor={'#FF9900'} />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { DivideIconShadow };
